module.exports = __webpack_public_path__ + "static/favicon-180-a0df36bbaf0fef2e239fb10fe52478a1.png";